import { ethers, BigNumber } from 'ethers'
import configs from '~/configs'

const rpcUrlPolygon = configs.POLYGON_NETWORK.rpc || 'https://rpc-amoy.polygon.technology/'
export const providerPolygon = new ethers.providers.JsonRpcProvider(rpcUrlPolygon)

export default providerPolygon
